export default {
  login: {
    title: '로그인',
    username: '사용자 이름',
    phone: '전화번호',
    phoneCode: '코드',
    email: '이메일',
    password: '비밀번호',
    captcha: '인증 코드',
    loading: '로딩 중...',
    rememberMe: '로그인 상태 유지',
    forgotPassword: '비밀번호를 잊으셨나요?',
    loginButton: '로그인',
    contactUs: '문의하기？',
    noAccount: '계정이 없으신가요?',
    registerNow: '회원가입',
    or: '또는',
    orSignInWith: '또는 다음으로 로그인',
    methodUsername: '사용자 이름',
    methodPhone: '전화',
    methodEmail: '이메일',
    usernameRequired: '사용자 이름을 입력하세요',
    phoneRequired: '전화번호를 입력하세요',
    emailRequired: '이메일을 입력하세요',
    passwordRequired: '비밀번호를 입력하세요',
    captchaRequired: '인증 코드를 입력하세요',
    resetPassword: '비밀번호 재설정',
    resetStep1Hint: '전화번호 또는 이메일을 입력하여 인증 코드를 받으세요.',
    useEmailInstead: '이메일 사용',
    usePhoneInstead: '전화 사용',
    sendCode: '코드 전송',
    resetStep2Hint: '인증 코드가 전송되었습니다',
    verificationCode: '인증 코드',
    verificationCodeRequired: '인증 코드를 입력하세요',
    resendIn: '재전송까지',
    resendCode: '코드 재전송',
    verify: '확인',
    resetStep3Hint: '새 비밀번호를 설정하세요.',
    newPassword: '새 비밀번호',
    confirmPassword: '비밀번호 확인',
    passwordMinLength: '비밀번호는 최소 6자 이상이어야 합니다',
    confirmPasswordRequired: '비밀번호를 확인하세요',
    passwordMismatch: '비밀번호가 일치하지 않습니다',
    resetPasswordBtn: '비밀번호 재설정',
    back: '뒤로',
    // Format validation
    emailFormat: '잘못된 이메일 형식',
    // Toast messages
    loginSuccess: '로그인 성공',
    loginFailed: '로그인 실패',
    signInWithGoogle: 'Google+로 로그인',
    codeSent: '인증 코드 전송됨',
    sendCodeFailed: '인증 코드 전송 실패',
    invalidCode: '잘못된 인증 코드',
    resetSuccess: '비밀번호가 재설정되었습니다',
    resetFailed: '비밀번호 재설정 실패'
  }
};
